module.exports = __webpack_public_path__ + "static/assets/108134b6504f4b26db347d028501b9e4.svg";